import { match } from "ts-pattern";

import type { AssessmentStatus } from "../types/assessment.js";

/**
 * Whether an assessment in this status is still being worked towards a
 * decision or completion, rather than finished.
 */
export const isAssessmentStatusUnderWay = (status: AssessmentStatus): boolean =>
  match(status)
    .with("open", "submitted", "returned", () => true)
    .with("approved", "completed", () => false)
    .exhaustive();
